<form
  [formGroup]="filtersForm"
  class="d-flex flex-wrap gap-5 mb-5"
>
  <base-filter-dropdown
    [items]="baseInquiryStatusOption"
    formControlName="status"
    filterName="state"
    optionClass="class"
  ></base-filter-dropdown>

  <base-filter-dropdown
    [items]="qualifications"
    filterName="qualifications.plural"
    formControlName="mainQualifications"
    [searchable]="true"
  ></base-filter-dropdown>

  <base-filter-dropdown
    [items]="departments"
    filterName="department.singular"
    formControlName="customerDepartments"
    [searchable]="true"
    [displaySubLabel]="true"
    [optionSubLabelSegments]="['customerLocation', 'name']"
  ></base-filter-dropdown>

  <base-filter-dropdown
    formControlName="createdBy"
    [items]="createdByCustomers"
    filterName="filter.createdBy"
    [multiple]="false"
    [combineLabel]="['firstName', 'lastName']"
  ></base-filter-dropdown>
</form>

<hr />

<div
  *ngIf="activeFilters.length > 0"
  class="d-flex align-items-center flex-wrap gap-3"
>
  <div
    *ngFor="let filter of activeFilters"
    class="rounded-pill px-4 py-2 bg-secondary active-filter btn-sm"
  >
    <span class="fw-normal">
      {{
        filter.filter === baseCustomerInquiryFilters.status
          ? ('state' | translate)
          : filter.filter === baseCustomerInquiryFilters.department
          ? ('department.singular' | translate)
          : filter.filter === baseCustomerInquiryFilters.mainQualification
          ? ('qualifications.singular' | translate)
          : filter.filter === baseCustomerInquiryFilters.search
          ? ('search.nominative' | translate)
          : ('filter.createdBy' | translate)
      }}:
    </span>
    {{
      (filter.value?.firstName && filter.value?.lastName
        ? filter.value.firstName + ' ' + filter.value.lastName
        : null) ||
        filter?.name ||
        filter.value?.name ||
        filter.value | translate
    }}
    <i
      class="fa-solid fa-xmark text-dark ms-2 pointer"
      (click)="removeFilter(filter)"
    ></i>
  </div>
  <span
    class="pointer"
    (click)="clearFilters()"
    *ngIf="activeFilters.length"
  >
    {{ 'filter.reset' | translate }}
  </span>
</div>

<div class="d-flex my-5 flex-column flex-md-row justify-content-between">
  <div class="col-12 col-md-6 col-xxl-4 col-xxxl-3">
    <base-search
      #searchField
      placeholder="inquiry.search.fullTextPlaceholder"
      [value]="activatedRoute.snapshot.queryParams.search"
      [useEnterEvent]="true"
      (query)="onSearchChange($event)"
    ></base-search>
  </div>
  <base-button
    class="col-12 col-md-6 col-xxl-4 col-xxxl-3 d-flex justify-content-md-end mt-2 mt-md-0"
    icon="fa-solid fa-plus"
    [iconSize]="buttonSizes.md"
    label="inquiry.new"
    (btnClick)="openNewStaffRequestModal()"
    color="primary"
  ></base-button>
</div>

<ng-template #staffRequest>
  <base-customer-staff-request-modal
    [selectedFilters]="filtersForm.value"
    [modalRef]="modalRef"
  ></base-customer-staff-request-modal>
</ng-template>
